module.exports = __webpack_public_path__ + "img/ctrl-pauli-root-stub-up-1.55f27022.svg";